"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_4 = require("@biomemakers/bmk_ui_framework");
const Representant_vue_1 = __importDefault(require("./Representant.vue"));
const bmk_ui_framework_5 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_6 = require("@biomemakers/bmk_ui_framework");
const TableSummaryProposalDetail_vue_1 = __importDefault(require("./TableSummaryProposalDetail.vue"));
const TableProposalDetail_vue_1 = __importDefault(require("./TableProposalDetail.vue"));
const bmk_ui_framework_7 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_8 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_9 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_10 = require("@biomemakers/bmk_ui_framework");
const trans_1 = require("@common/tsutils/trans");
const Proposal_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Proposal"));
const GISArea_1 = __importDefault(require("@becrop/components/Modules/Common/Models/GISArea"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const TableTrialsTracking_vue_1 = __importDefault(require("../../Trials/TableTrialsTracking.vue"));
const TableStudiesTracking_vue_1 = __importDefault(require("../../Trials/TableStudiesTracking.vue"));
const TableSummaryTrialsDetails_vue_1 = __importDefault(require("../../Trials/TableSummaryTrialsDetails.vue"));
const GISModal_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Detail/GISModal.vue"));
const QuoteLinkerModal_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Detail/QuoteLinkerModal.vue"));
const ThirdPartiesModal_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/ThirdPartiesModal.vue"));
const ThirdPartiesManager_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Abstract/Controllers/ThirdPartiesManager"));
const Provider_1 = require("@becrop/components/Common/ThirdParties/Abstract/Models/Provider");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let ProposalDetailYield = class ProposalDetailYield extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.eventTracker = new EventTracker_1.default();
        this.textSearch = '';
        this.phaseOccupacySelector = '';
        this.toastActive = true;
        this.userHook = 'user';
        this.bmkHook = 'bmk';
        this.pendingHook = 'pending';
        this.thirdPartiesController = new ThirdPartiesManager_1.default(this.leafUserId);
        this.isGISModalDeployed = false;
        this.isQuoteLinkerModalDeployed = false;
        this.isThirdPartiesModalDeployed = false;
        this.activeThirdPartyStage = 'list';
        this.activeProvider = new Provider_1.Provider({});
        this.activeProviderAreas = [];
        this.selectedBlocks = [];
        this.isImportingToastActive = false;
        this.importingToastSuccessful = true;
        this.thirdPartiesMessage = '';
        this.onSampleShippingLoading = false;
        this.hooks = [this.userHook, this.bmkHook, this.pendingHook];
        this.criteria = '';
        this.direction = 0;
        this.idActive = -1;
        this.areaActive = new GISArea_1.default({});
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.theadElements = [
            {
                name: (0, trans_1.trans)('tracking.life_cycles.gis_file_upload.title_min'),
                slug: 'gis_file_upload',
            },
            {
                name: (0, trans_1.trans)('tracking.life_cycles.calculating_zones.title_min'),
                slug: 'calculating_zones',
            },
            {
                name: (0, trans_1.trans)('tracking.life_cycles.sample_collecting.title_min'),
                slug: 'sample_collecting',
            },
            {
                name: (0, trans_1.trans)('tracking.life_cycles.sample_shipping.title_min'),
                slug: 'sample_shipping',
            },
            {
                name: (0, trans_1.trans)('tracking.life_cycles.laboratory.title_min'),
                slug: 'lab_quality_control',
            },
            {
                name: (0, trans_1.trans)('tracking.life_cycles.metadata.title_min'),
                slug: 'metadata',
            },
            {
                name: (0, trans_1.trans)('tracking.life_cycles.result.title_min'),
                slug: 'result',
            },
        ];
        this.currentProposal = new Proposal_1.default({
            id: 0,
            name: '',
            code_name: '',
            accepted_at: '',
            contact: {
                name: '',
                email: '',
            },
            status: {
                slug: '',
                name: '',
                phase: '',
            },
            deliverables: [],
        });
        this.fixedProjectLines = [];
        this.isLoadingTrialsTable = false;
        this.istoastTrialsNotGheom = false;
        this.trialsHasGheom = false;
        this.trialsHasSamples = false;
        this.tableTrialsGlobalTextSearch = '';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    eventTrackerListener(eventName, data) {
        this.eventTracker.trackEvent(eventName, data);
    }
    providers() {
        return this.thirdPartiesController.providers;
    }
    triggerAreaPlayground(mode) {
        this.$emit('loadareaplaygroundarea', this.idActive, this.currentProposal.id, mode);
    }
    triggerThirdPartiesList() {
        this.dismissGISModal();
        this.deployThirdPartiesModal();
    }
    triggerQuoteLinker() {
        this.dismissGISModal();
        this.deployQuoteLinkerModal();
    }
    dismissToastTrialsNotGheom() {
        this.istoastTrialsNotGheom = false;
    }
    toastTrialsNotGheom(hasGheom) {
        this.trialsHasGheom = hasGheom;
        if (hasGheom) {
            this.istoastTrialsNotGheom = false;
        }
        else {
            this.istoastTrialsNotGheom = true;
        }
    }
    loadingTrialsTable(value) {
        this.isLoadingTrialsTable = value;
    }
    async confirmConnection(p, gisAreaId) {
        this.activeThirdPartyStage = 'bridge';
        await this.thirdPartiesController.connectProvider(p, gisAreaId);
        this.eventTrackerListener('connectedToThirdParties', {
            origin: 'tracking',
            provider: p.name
        });
    }
    async connectProvider(p, gisAreaId) {
        this.activeProvider = p;
        this.eventTrackerListener('attempToConnectToThirdParties', {
            origin: 'tracking',
            provider: p.name
        });
        if (this.hasDisclaimer) {
            this.activeThirdPartyStage = 'disclaimer';
        }
        else {
            await this.confirmConnection(p, gisAreaId);
        }
    }
    async listProvider(p) {
        this.activeProvider = p;
        this.activeThirdPartyStage = 'fetching';
        await this.thirdPartiesController.fetchProviderAreas(p, 'areas');
        this.activeProviderAreas = this.thirdPartiesController.activeProviderAreas;
        this.activeThirdPartyStage = 'blocklist';
    }
    deployGISModal() {
        this.isGISModalDeployed = true;
    }
    deployQuoteLinkerModal() {
        this.isQuoteLinkerModalDeployed = true;
    }
    dismissGISModal() {
        this.isGISModalDeployed = false;
    }
    dismissQuoteLinkerModal() {
        this.isQuoteLinkerModalDeployed = false;
    }
    deployThirdPartiesModal() {
        this.isThirdPartiesModalDeployed = true;
    }
    dismissThirdPartiesModal() {
        this.isThirdPartiesModalDeployed = false;
        this.backToList();
    }
    dismissThirdPartiesToast() {
        this.isImportingToastActive = false;
    }
    backToList() {
        this.activeThirdPartyStage = 'list';
    }
    afterConnection() {
        this.backToList();
    }
    backToBlocks() {
        this.activeThirdPartyStage = 'blocklist';
    }
    async addSelected(b) {
        this.selectedBlocks = b;
        this.activeThirdPartyStage = 'importingData';
        try {
            const resp = await this.thirdPartiesController.addSelected(b, 'areas', this.areaActive);
            if (resp.status == 200) {
                this.setPhaseAsDone('gis_file_upload', this.areaActive.meta.id);
                this.activeThirdPartyStage = 'successfulImport';
            }
            else {
                this.thirdPartiesMessage = resp.response.data.messages;
                this.activeThirdPartyStage = 'failedImport';
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    // Array containing the drafts of the proposasl
    activeSelector(activeValue) {
        if (this.phaseOccupacySelector == activeValue ||
            activeValue === '' ||
            activeValue.charAt(0) === '#') {
            this.phaseOccupacySelector = '';
        }
        else {
            this.phaseOccupacySelector = activeValue;
        }
    }
    setPhaseAsDone(phaseSlug, areaID) {
        this.$emit('setphaseasdone', phaseSlug, areaID);
    }
    // Function that saves the text entered in the search engine
    onchangesearch(text) {
        this.textSearch = text;
        this.filterLines(text);
    }
    onchangesearchtrials(searchText) {
        this.tableTrialsGlobalTextSearch = searchText;
    }
    breadcrumbClicked(name) {
        this.mixpanelHandler.trackEvent('breadcrumbClicked', {
            target: name,
            origin: 'detail',
        });
    }
    //Function determining breadcroms activated
    launchCrumb(name) {
        this.$emit('launchcrumb', name);
    }
    deployGISUploader(id, status) {
        // this.$emit('loadareaplaygroundarea', id, this.currentProposal.id);
        this.idActive = id;
        this.areaActive = this.fixedProjectLines.find((p) => p.area.meta.id === id).area;
        if (status === 'pending') {
            this.deployGISModal();
        }
        else {
            this.triggerAreaPlayground('view');
        }
    }
    deployQuoteLinker() {
        this.deployQuoteLinkerModal();
    }
    onResetGisArea(id) {
        this.idActive = id;
        this.areaActive = this.fixedProjectLines.find((p) => p.area.meta.id === id).area;
        this.$emit('onResetGisArea', id, this.currentProposal.id);
    }
    deployMapZones(data, area) {
        this.$emit('loadareaplaygroundzones', data, area);
    }
    get hasTableTrials() {
        return this.proposal.deliverables.some((d) => d.type === 'trials');
    }
    get hasStudyProjects() {
        return this.proposal.deliverables.some((d) => d.type === 'study');
    }
    get studyProjectIds() {
        return this.proposal.deliverables
            .filter((d) => d.type === 'study')
            .map((d) => d.project_id);
    }
    get proposalAccent() {
        var _a, _b;
        let accent = 'success';
        switch ((_b = (_a = this.currentProposal) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.phase) {
            case this.userHook:
                accent = 'primary';
                break;
            case this.bmkHook:
                accent = 'info';
                break;
        }
        return accent;
    }
    get proposalToastTitle() {
        var _a, _b, _c, _d;
        let action = '';
        switch ((_b = (_a = this.currentProposal) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.phase) {
            case this.userHook:
                action =
                    (0, trans_1.trans)('tracking.action_required') +
                        ': ' +
                        ((_d = (_c = this.currentProposal) === null || _c === void 0 ? void 0 : _c.status) === null || _d === void 0 ? void 0 : _d.name) +
                        ' ' +
                        (0, trans_1.trans)('tracking.pending_some');
                break;
            case this.bmkHook:
                action = (0, trans_1.trans)('tracking.og');
                break;
        }
        return action;
    }
    get projectLines() {
        const projects = [];
        if (this.currentProposal.deliverables) {
            this.currentProposal.deliverables.forEach((d) => {
                d.areas.forEach((a) => {
                    // check if area already exists in array
                    const areaIx = projects.findIndex((p) => p.area.meta.id === a.meta.id);
                    if (areaIx === -1) {
                        projects.push({
                            type: d.type,
                            area: a,
                            category: d.category,
                            project_id: d.project_id,
                            visibility: d.visibility,
                        });
                    }
                    else {
                        projects[areaIx].type += '\n' + d.type;
                    }
                });
            });
        }
        return projects;
    }
    filterLines(cri) {
        this.fixedProjectLines = this.projectLines.filter((pl) => {
            var _a;
            if (cri === '#user') {
                if (pl.area.status.phase === 'user') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (cri === '#bmk') {
                if (pl.area.status.phase === 'bmk') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (cri === '#pending') {
                if (((_a = pl.area.status) === null || _a === void 0 ? void 0 : _a.slug) !== 'completed') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                if (pl.type
                    .toString()
                    .toLowerCase()
                    .trim()
                    .includes(cri.toLowerCase().trim()) ||
                    pl.area.meta.name
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(cri.toLowerCase().trim()) ||
                    pl.area.meta.crop.logo_name
                        .toLowerCase()
                        .trim()
                        .includes(cri.toLowerCase().trim()) ||
                    pl.area.meta.crop.name
                        .toLowerCase()
                        .trim()
                        .includes(cri.toLowerCase().trim())) {
                    return true;
                }
                else {
                    return false;
                }
            }
        });
        this.updateSort();
    }
    closeToast() {
        this.mixpanelHandler.trackEvent('dismissProposalStatusToast', {
            id: this.currentProposal.id,
        });
        this.toastActive = false;
    }
    updateSortable(newCriteria) {
        const directions = [-1, 0, 1];
        if (newCriteria !== this.criteria) {
            this.criteria = newCriteria;
            this.direction = directions[2];
        }
        else {
            let dirIx = directions.findIndex((d) => d === this.direction);
            dirIx === directions.length - 1 ? (dirIx = 0) : (dirIx = dirIx + 1);
            this.direction = directions[dirIx];
        }
        this.updateSort();
    }
    updateSort() {
        function fixNullsValue(val) {
            let temp = val;
            if (!val)
                temp = '---';
            return temp;
        }
        function getMyKey(criteria) {
            if (criteria === 'gis_file_upload')
                return 'gis_file_upload';
            if (criteria === 'calculating_zones')
                return 'calculating_zones';
            if (criteria === 'sample_collecting')
                return 'sample_collecting';
            if (criteria === 'sample_shipping')
                return 'sample_shipping';
            if (criteria === 'lab_quality_control')
                return 'lab_quality_control';
            if (criteria === 'metadata')
                return 'metadata';
            if (criteria === 'result')
                return 'result';
            return 'name';
        }
        const keyToSort = getMyKey(this.criteria);
        this.fixedProjectLines.sort((a, b) => {
            if (keyToSort !== 'name') {
                const dateA = a.area.life_cycle_area.find((lf) => (lf === null || lf === void 0 ? void 0 : lf.slug) === keyToSort).completed_at;
                const dateB = b.area.life_cycle_area.find((lf) => (lf === null || lf === void 0 ? void 0 : lf.slug) === keyToSort).completed_at;
                if (this.direction === -1) {
                    return fixNullsValue(dateA) > fixNullsValue(dateB) ? -1 : 1;
                }
                if (this.direction === 1) {
                    return fixNullsValue(dateA) < fixNullsValue(dateB) ? -1 : 1;
                }
            }
            else {
                return a.area.meta.name.localeCompare(b.area.meta.name);
            }
        });
    }
    contactRepresentant(e) {
        const element = e.target;
        const fromButton = element.classList.contains('bmfw-button');
        if (fromButton) {
            this.mixpanelHandler.trackEvent('representantClicked', {
                id: this.currentProposal.id,
            });
        }
    }
    switchToResults(payload) {
        this.$emit('switchToResults', payload);
    }
    updateProposal() {
        this.currentProposal = this.proposal;
        this.fixedProjectLines = this.projectLines;
    }
    async mounted() {
        if (!this.proposal) {
            this.currentProposal = new Proposal_1.default({});
        }
        else {
            this.currentProposal = this.proposal;
        }
        this.fixedProjectLines = this.projectLines;
        this.updateSort();
        await this.thirdPartiesController.fetchProvidersList();
        this.thirdPartiesController.checkIfRedirected();
        if (this.thirdPartiesController.comesFromRedirection) {
            this.areaActive = this.fixedProjectLines.find((p) => Number(p.area.meta.id) === Number(this.thirdPartiesController.activeGisArea)).area;
            this.deployThirdPartiesModal();
            this.activeProvider = this.thirdPartiesController.redirectedProvider;
            if (this.activeProvider.linked) {
                this.activeThirdPartyStage = 'success';
            }
            else {
                this.activeThirdPartyStage = 'error';
            }
        }
        const url = new URL(window.location.href);
        if (url.searchParams.has('showingArea')) {
            const gisAreaID = parseInt(url.searchParams.get('showingArea'));
            url.searchParams.delete('showingArea');
            this.deployGISUploader(gisAreaID, '');
            // history.pushState({}, '-', url.href);
            window.history.pushState({}, document.title, url);
        }
        if (url.searchParams.has('sampling')) {
            this.$emit('onChangeSamplingStepStatus', 'sampling');
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ProposalDetailYield.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'default' })
], ProposalDetailYield.prototype, "samplingStepStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProposalDetailYield.prototype, "hasDisclaimer", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProposalDetailYield.prototype, "isBMK", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProposalDetailYield.prototype, "isProduct", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProposalDetailYield.prototype, "canUploadTracking", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ProposalDetailYield.prototype, "proposal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], ProposalDetailYield.prototype, "leafUserId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], ProposalDetailYield.prototype, "proposalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], ProposalDetailYield.prototype, "projectId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProposalDetailYield.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('proposal')
], ProposalDetailYield.prototype, "updateProposal", null);
ProposalDetailYield = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            PageHeading: bmk_ui_framework_4.PageHeading,
            Yield: bmk_ui_framework_7.Yield,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_2.BreadcrumbsItem,
            HomeIcon: bmk_ui_framework_3.HomeIcon,
            TableSummaryProposalDetail: TableSummaryProposalDetail_vue_1.default,
            Separator: bmk_ui_framework_5.Separator,
            Toasts: bmk_ui_framework_6.Toasts,
            Representant: Representant_vue_1.default,
            TableProposalDetail: TableProposalDetail_vue_1.default,
            ViewZero: bmk_ui_framework_8.ViewZero,
            ParcelsIcon: bmk_ui_framework_9.ParcelsIcon,
            Info: lucide_vue_next_1.Info,
            TableTrialsTracking: TableTrialsTracking_vue_1.default,
            TableStudiesTracking: TableStudiesTracking_vue_1.default,
            TableSummaryTrialsDetails: TableSummaryTrialsDetails_vue_1.default,
            Loading: bmk_ui_framework_10.Loading,
            WarningSquaredIcon: bmk_ui_framework_1.WarningSquaredIcon,
            GISModal: GISModal_vue_1.default,
            QuoteLinkerModal: QuoteLinkerModal_vue_1.default,
            ThirdPartiesModal: ThirdPartiesModal_vue_1.default
        },
        emits: ['triggerThirdPartiesList', 'loadareaplaygroundarea', 'setphaseasdone']
    })
], ProposalDetailYield);
exports.default = ProposalDetailYield;
